import EmptyState from './EmptyState';

export default EmptyState;


// WEBPACK FOOTER //
// ./src/components/emptyState/index.js